import store from '@/store/store.js'
import axios from 'axios'
import router from '../router.js'
import Constants from '@/js/constant.js'

const PROFILE = 'profile'

export default {
  getProfile (context, data) {
    axios.get(PROFILE, { headers: { Authorization: `Bearer ${data.data.access_token}` } }).then((response) => {
      localStorage.setItem('access_token', data.data.access_token)
      console.log('user_roles', response.data.roles)
      localStorage.setItem('user_roles', Constants.convertObjectToString(response.data.roles))
      store.commit('UPDATE_USER_INFO', {displayName: response.data.name, email: response.data.email, photoURL: null})
      axios.defaults.headers.common['Authorization'] = `Bearer ${data.data.access_token}`
      context.$vs.loading.close()
      context.isLoading = false
      if (response.data.roles.type !== 'Main-Admin') {
        router.push('/prospects').catch(() => {})
      } else {
        router.push('/prospects').catch(() => {})
      }
    }, () => {
      this.$vs.loading.close()
    })
  },
  getProfileFromToken (context, token) {
    axios.get(PROFILE, { headers: { Authorization: `Bearer ${token}` } }).then((response) => {
      localStorage.setItem('access_token', token)
      console.log('user_roles', response.data.roles)
      localStorage.setItem('user_roles', Constants.convertObjectToString(response.data.roles))
      store.commit('UPDATE_USER_INFO', {displayName: response.data.name, email: response.data.email, photoURL: null})
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      context.$vs.loading.close()
      context.isLoading = false
      router.push('/prospects').catch(() => {})
    }, () => {
      this.$vs.loading.close()
    })
  },
  isMainAdmin () {
    const profile = JSON.parse(localStorage.getItem('user_roles'))
    return profile.type === 'Main-Admin'
  }
}
